import actionCreator from 'helpers/actionCreator'
import { ADD_NETWORK_CLOSET, DELETE_NETWORK_CLOSET,
  ADD_WIRED_DEVICE, DELETE_WIRED_DEVICE, CHANGE_WIRED_DEVICE_TYPE,
  DUPLICATE_WIRED_DEVICE, ADD_WIRE, DELETE_WIRE,
  REMOVE_DEVICE_WIRES, ADD_WIRE_TOOLTIP_MAP_REFERENCE, UPDATE_ENTITY,
  ADD_DOOR_CONTROLLER, ADD_DOOR, ADD_PERIPHERAL, ADD_EXPANSION_CONTROLLER,
  DESTROY_DOOR_CONTROLLER, DELETE_DOOR_CONTROLLER, DELETE_DOOR,
  DELETE_PERIPHERAL, CHANGE_MAIN_CONTROLLER_MODEL,
  CHANGE_DOOR_CONTROLLER_MODEL } from 'actions/entityActionTypes'

/** actions for network closets */
export const addNetworkClosetAction = actionCreator(ADD_NETWORK_CLOSET, 'location')
export const deleteNetworkClosetAction = actionCreator(DELETE_NETWORK_CLOSET, 'id')

/** actions for generic wired devices */
export const addWiredDeviceAction = actionCreator(ADD_WIRED_DEVICE, 'location', 'deviceType')
export const deleteWiredDeviceAction = actionCreator(DELETE_WIRED_DEVICE, 'id')
export const changeWiredDeviceTypeAction = actionCreator(CHANGE_WIRED_DEVICE_TYPE, 'id', 'newType')
export const duplicateWiredDeviceAction = actionCreator(DUPLICATE_WIRED_DEVICE, 'location', 'id')

/** actions for wires */
export const addWireAction = actionCreator(ADD_WIRE, 'overlay', 'start', 'end', 'showTooltip')
export const deleteWireAction = actionCreator(DELETE_WIRE, 'id', 'resetCurrentEntity')
export const removeDeviceWiresAction = actionCreator(REMOVE_DEVICE_WIRES, 'id', 'endType')
export const addWireTooltipMapReferenceAction = actionCreator(ADD_WIRE_TOOLTIP_MAP_REFERENCE, 'overlay')

/** actions for access control */
export const addDoorControllerAction = actionCreator(ADD_DOOR_CONTROLLER, 'location')
export const addDoorAction = actionCreator(ADD_DOOR, 'controllerId', 'location')
export const addPeripheralAction = actionCreator(ADD_PERIPHERAL, 'peripheralType', 'doorId')
export const addExpansionControllerAction = actionCreator(ADD_EXPANSION_CONTROLLER, 'parentId', 'location', 'model')
export const destroyDoorControllerAction = actionCreator(DESTROY_DOOR_CONTROLLER, 'id')
export const deleteDoorControllerAction = actionCreator(DELETE_DOOR_CONTROLLER, 'id', 'resetCurrentEntity')
export const deleteDoorAction = actionCreator(DELETE_DOOR, 'id')
export const deletePeripheralAction = actionCreator(DELETE_PERIPHERAL, 'peripheralType', 'id', 'doorId')
export const changeMainControllerModelAction = actionCreator(CHANGE_MAIN_CONTROLLER_MODEL, 'id', 'model', 'limitsExceeded')
export const changeDoorControllerModelAction = actionCreator(CHANGE_DOOR_CONTROLLER_MODEL, 'id', 'model', 'limitsExceeded')

/** actions for updating entities */
export const updateEntityAction = actionCreator(UPDATE_ENTITY, 'entityType', 'id', 'updates')
export const updateNetworkClosetAction = updateEntityAction.bind(null, 'networkClosets')
export const updateWiredDeviceAction = updateEntityAction.bind(null, 'wiredDevices')
export const updateWireAction = updateEntityAction.bind(null, 'wires')



// WEBPACK FOOTER //
// ./src/actions/entityActions.js